import { useCallback } from "react";
import { useSelector } from 'react-redux';
import { selectors as stationsSelectors } from 'store/features/stations';
import { IStation } from 'dataSources/Typicode/stations/types/station';

const useGetStationByCode = () => {
  const allStationsMap = useSelector(stationsSelectors.allStationsMap);

  const getStationByCode = useCallback((stationCode: IStation['code']) => (
    allStationsMap[stationCode]
  ), [allStationsMap]);

  return getStationByCode;
};

export default useGetStationByCode;
